import React, { useCallback } from 'react'
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Typography,
    useMediaQuery,
    useTheme,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { batch, useDispatch } from 'react-redux'
import {
    markSmbCartItemForDeletion,
    removeFromSmbCart,
} from '../../../../actions/smbCart'
import makeStyles from '@material-ui/core/styles/makeStyles'
import {
    getCardType,
    renderProductName,
} from '../../../../containers/SMBOrderFlow'

const useStyles = makeStyles((theme) => ({
    deleteCartItemModalTitle: {
        fontSize: '1.5rem',
        margin: '0',
    },
    deleteCartItemModalCloseBtn: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    deleteCartItemModalHelperText: {
        color: theme.palette.black.main,
    },
    productDetailsContainer: {
        marginBottom: '2rem',
    },
    productName: {
        fontWeight: 'bold',
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        },
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
    },
    cancelButton: {
        order: 1,
        border: '2px solid',
        marginBottom: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            order: 0,
            flexGrow: 2,
            marginBottom: 0,
        },
    },
    deleteButton: {
        marginBottom: '1rem',
        [theme.breakpoints.up('sm')]: {
            flexGrow: 2,
            marginBottom: 0,
            marginLeft: theme.spacing(1),
        },
    },
}))

const DeleteCartItemModal = ({ open, item, cartId }) => {
    const theme = useTheme()
    const classes = useStyles()
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))
    const dispatch = useDispatch()
    const { product, cards, priceWithProcessingFees } = item

    const handleRemoveFromCart = () => {
        batch(() => {
            dispatch(
                removeFromSmbCart({
                    cart_id: cartId,
                    delivery_group_uuid: item.deliveryGroupId,
                })
            )
            dispatch(
                markSmbCartItemForDeletion({
                    openModal: false,
                    cartId: null,
                    item: null,
                })
            )
        })
    }

    const handleClose = useCallback(() => {
        dispatch(
            markSmbCartItemForDeletion({
                openModal: false,
                cartId: null,
                item: null,
            })
        )
    }, [dispatch])

    return (
        <Dialog
            open={open}
            fullWidth={true}
            fullScreen={fullScreen}
            maxWidth={'sm'}
            aria-labelledby="Delete cart item"
        >
            <DialogTitle id="max-width-dialog-title">
                <Box display="flex" flexDirection="row">
                    <ErrorOutlineIcon
                        color="primary"
                        style={{ fontSize: '2rem', alignSelf: 'center' }}
                    />
                    <div style={{ marginLeft: 5, fontSize: '1.75rem' }}>
                        Delete?
                    </div>
                </Box>
                <IconButton
                    className={classes.deleteCartItemModalCloseBtn}
                    aria-label="Close delete cart item modal"
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers style={{ borderBottom: 0 }}>
                <DialogContentText
                    className={classes.deleteCartItemModalHelperText}
                >
                    Deleting this item from your cart will delete the card and
                    all recipient details that were entered:
                </DialogContentText>
                <div className={classes.productDetailsContainer}>
                    <Typography className={classes.productName}>
                        {renderProductName(
                            product.cardNetwork,
                            product.isVirtual
                        )}
                    </Typography>
                    <Typography>
                        Type: {getCardType(product.cardType)}
                    </Typography>
                    <Typography>Price: ${priceWithProcessingFees}</Typography>
                    <Typography>Quantity: {cards.length}</Typography>
                </div>
                <div className={classes.buttonContainer}>
                    <Button
                        className={classes.cancelButton}
                        variant="outlined"
                        color="primary"
                        size={'large'}
                        aria-label="Cancel deleting cart item"
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        className={classes.deleteButton}
                        variant="contained"
                        color="primary"
                        size={'large'}
                        aria-label="Delete card from cart"
                        onClick={handleRemoveFromCart}
                    >
                        Delete this card
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default DeleteCartItemModal
